<template>
  <nav class="member-navbar">
    <!-- <router-link :class="{ active: activeLink == 'news' }" to="/member/news"
      >最新消息</router-link
    > -->
    <router-link :class="{ active: activeLink == 'member' }" to="/member/member"
      >會員專區</router-link
    >
    <router-link
      :class="{ active: activeLink == 'order' }"
      to="/member/order-main"
      >訂購區</router-link
    >
    <!-- <router-link
      :class="{ active: activeLink == 'website' }"
      to="/member/website"
      >公司網站</router-link
    > -->
  </nav>
</template>
<script>
export default {
  name: "MemberNavbar",
  props: ["activeLink"],
  updated() {},
};
</script>
<style scope>
</style>